class WizzyGeoComponent {

    constructor() {
        this.apiPath="https://nv0lfbt1zk.execute-api.us-east-1.amazonaws.com/geocode?zip={zip}&radius={radius}";
        this.currentZip = null;
        this.currentRadius = null;
        this.currentStores = null;
    }

    init() {
        let zipcode = localStorage.getItem("wizzy-last-zip");
        let radius = localStorage.getItem("wizzy-last-location-radius");

        if(zipcode) this.currentZip = zipcode;
        if(radius) this.currentRadius = radius;
    }

    makeApiPath() {
        let zip = this.currentZip;
        let radius = this.currentRadius;
        let url = this.apiPath;
        url = url.replace("{zip}", zip);
        url = url.replace("{radius}", radius);
        return url;
    }

    makeApiCall() {
        
        console.log("<====== VIEW RENDERED");
        console.log(this.currentZip, "<====zipcode");
        console.log(this.currentZip.length, "<====zipcode count");

        if (this.currentZip && this.currentZip.length==5) {
            let url = this.makeApiPath();

            const xhr = new XMLHttpRequest();
            xhr.open("POST", url);
            xhr.setRequestHeader("x-store-id", wizzyConfig.credentials.storeId);
            xhr.setRequestHeader("x-store-key", wizzyConfig.credentials.apiKey);
            xhr.setRequestHeader("Accept", "application/json");

            xhr.onreadystatechange = () => {
                if(xhr.readyState === 4) {
                    if(xhr.status === 200) {
                        const response = JSON.parse(xhr.responseText);
                        this.handleApiData(response);
                        this.executeWizzyFilterAPI();
                    }else {
                        console.error(xhr.status, "<==== WIZZY make API call");
                    }
                }
            }

            xhr.send();

        }
    }

    handleApiData(data) {
        if (data.hasOwnProperty("result")) {
            this.currentStores = data.result;
            window.localStorage.setItem("wizzy_product_inventory_sources_ids", JSON.stringify(this.currentStores.map(function(item) {
                return item.id;
            })))
        }
    }

    getSelectedLoactionIds() {
        return window.localStorage.getItem("wizzy_product_inventory_sources_ids");
    }

    executeWizzyFilterAPI() {
        let base=[
            window.location.origin,
            window.location.pathname
        ].join('');

        let product_inventory_sources_idsUrlData = [];
        let proudctSourceIds=JSON.parse(this.getSelectedLoactionIds());
        
        for (let i in proudctSourceIds) {
            product_inventory_sources_idsUrlData.push(['product_inventory_sources_ids[]',proudctSourceIds[i]].join('='))
        }

        product_inventory_sources_idsUrlData=product_inventory_sources_idsUrlData.join('&')
        let searchKey = window.wizzyConfig.pageStore.searchedResponse.filters.searchedKey
        let q = window.wizzyConfig.pageStore.searchSubmitValue;

        let qString = '';
        if (q && q.length) {
            qString="&q="+q;
        }
        
        let filterUrl = [base,`attributeFacetValuesLimit=50&currency=USD&getAllVariants=false&page=1&${product_inventory_sources_idsUrlData}&productsCount=20${qString}&searchedKey=${searchKey}&showOOSProductsInOrder=false&sort_field[]=product_value_tags_image_based_sort_ruled_based%3Afloat&sort_field[]=relevance&sort_order[]=asc&sort_order[]=asc&type=DEFAULT`].join('?');
        window.executeWizzyFiltersFromURL(filterUrl);
    }

}


window.wizzyGeoCodeFilter = new WizzyGeoComponent();